import { Injectable, SimpleChange, SimpleChanges } from '@angular/core';
import { FromAndTo } from '@com-delta-omnichannel/mach-core-js';
import { FROM, TO } from '../constants/airport-dropdown-modal.constants';
import {
  AirportDropDownList,
  DestinationType
} from '../models/airport-dropdown.interfaces';
import { UiStateManagementBaseService } from './ui-state-management-base.service';

interface EventService {
  emitAirportCodeUpdate(airportCode: string): void;
}

@Injectable({
  providedIn: 'root'
})
export class UiStateManagementService extends UiStateManagementBaseService {
  setExpandView(value: boolean): void {
    this.expandViewSubject.next(value);
  }

  toggleExpandView(): void {
    this.expandViewSubject.next(!this.expandViewSubject.value);
  }

  setToggleAirportDropDown(value: boolean): void {
    this.toggleAirportDropDownSubject.next(value);
  }

  toggleAirportDropDown(): boolean {
    const newValue = this.toggleAirportDropDownSubject.value;
    this.toggleAirportDropDownSubject.next(newValue);
    return newValue;
  }

  getCurrentExpandView(): boolean {
    return this.expandViewSubject.value;
  }

  setAirportUI(
    airportPicker: FromAndTo,
    airportValue: AirportDropDownList,
    destinationType: DestinationType,
    onAirportChange?: (airportCode: string) => void
  ): void {
    if (destinationType === FROM) {
      airportPicker.setOrigin(airportValue.code, airportValue.name);
      onAirportChange?.(airportValue.code);
    } else if (destinationType === TO) {
      airportPicker.setDestination(airportValue.code, airportValue.name);
      onAirportChange?.(airportValue.code);
    }
  }

  handleModalToggle(closeModal: boolean): boolean {
    this.setToggleAirportDropDown(!closeModal);
    return this.toggleAirportDropDown();
  }

  handleComponentChanges(
    changes: SimpleChanges,
    airportPicker: FromAndTo,
    destinationType: DestinationType,
    eventService: EventService
  ): void {
    this.handleAirportSelectedChange(
      changes['airportSelected'],
      airportPicker,
      destinationType,
      eventService
    );
  }

  private handleAirportSelectedChange(
    change: SimpleChange,
    airportPicker: FromAndTo,
    destinationType: DestinationType,
    eventService: EventService
  ): void {
    if (change?.currentValue?.code && destinationType) {
      this.setAirportUI(
        airportPicker,
        change.currentValue,
        destinationType,
        (airportCode) => eventService.emitAirportCodeUpdate(airportCode)
      );
    }
  }
}
